import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GroupPlaybackControls } from '../../../../../motion-dom/dist/es/animation/controls/Group.mjs';
import { getValueTransition } from '../../../../../motion-dom/dist/es/animation/utils/get-value-transition.mjs';
import '../../../../../motion-utils/dist/es/errors.mjs';
import { secondsToMilliseconds } from '../../../../../motion-utils/dist/es/time-conversion.mjs';
import { frame } from '../../frameloop/frame.mjs';
import { MotionGlobalConfig } from '../../utils/GlobalConfig.mjs';
import { instantAnimationState } from '../../utils/use-instant-transition-state.mjs';
import { AcceleratedAnimation } from '../animators/AcceleratedAnimation.mjs';
import { MainThreadAnimation } from '../animators/MainThreadAnimation.mjs';
import { getFinalKeyframe } from '../animators/waapi/utils/get-final-keyframe.mjs';
import { getDefaultTransition } from '../utils/default-transitions.mjs';
import { isTransitionDefined } from '../utils/is-transition-defined.mjs';
var animateMotionValue = function animateMotionValue(name, value, target) {
  var transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var element = arguments.length > 4 ? arguments[4] : undefined;
  var isHandoff = arguments.length > 5 ? arguments[5] : undefined;
  return function (_onComplete) {
    var valueTransition = getValueTransition(transition, name) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    var delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    var _transition$elapsed = transition.elapsed,
      elapsed = _transition$elapsed === void 0 ? 0 : _transition$elapsed;
    elapsed = elapsed - secondsToMilliseconds(delay);
    var options = _objectSpread(_objectSpread({
      keyframes: Array.isArray(target) ? target : [null, target],
      ease: "easeOut",
      velocity: value.getVelocity()
    }, valueTransition), {}, {
      delay: -elapsed,
      onUpdate: function onUpdate(v) {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: function onComplete() {
        _onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      },
      name: name,
      motionValue: value,
      element: isHandoff ? undefined : element
    });
    /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
      options = _objectSpread(_objectSpread({}, options), getDefaultTransition(name, options));
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    if (options.duration) {
      options.duration = secondsToMilliseconds(options.duration);
    }
    if (options.repeatDelay) {
      options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
    }
    if (options.from !== undefined) {
      options.keyframes[0] = options.from;
    }
    var shouldSkip = false;
    if (options.type === false || options.duration === 0 && !options.repeatDelay) {
      options.duration = 0;
      if (options.delay === 0) {
        shouldSkip = true;
      }
    }
    if (instantAnimationState.current || MotionGlobalConfig.skipAnimations) {
      shouldSkip = true;
      options.duration = 0;
      options.delay = 0;
    }
    /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */
    if (shouldSkip && !isHandoff && value.get() !== undefined) {
      var finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
      if (finalKeyframe !== undefined) {
        frame.update(function () {
          options.onUpdate(finalKeyframe);
          options.onComplete();
        });
        // We still want to return some animation controls here rather
        // than returning undefined
        return new GroupPlaybackControls([]);
      }
    }
    /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    if (!isHandoff && AcceleratedAnimation.supports(options)) {
      return new AcceleratedAnimation(options);
    } else {
      return new MainThreadAnimation(options);
    }
  };
};
export { animateMotionValue };